import { GridLayout } from "../components/layout"

export function SkeletonDiv({ style, className }) {
    return (
        <div className={`${className} skeleton-loader`} style={style}></div>
    )
}

export function SkeletonCircle({ style, className }) {
    return (
        <div className={`${className} skeleton-loader skeleton-circle`} style={style}></div>
    )
}

export function SkeletonCardCourses({ show=12, className }) {
    return (
            <GridLayout role="skeleton-loader" className={`${className} skeleton-card-grid`} style={{ gridAutoRows: "240px" }} columnsTemplate="1fr 1fr 1fr 1fr" gap="16px">
            {[...Array(show)].map((_, i) => (
                <div key={i} className="vertical course-comp standard-rounded standard-border">
                    <SkeletonDiv style={{ height: "10rem" }} className="course-img" />
                    <div>
                        <div className="small-standard-padding">
                            <SkeletonDiv style={{ height: "19.5px" }} className="standard-rounded" />
                        </div>
                        <GridLayout className="small-standard-padding no-padding-top" columnsTemplate="1fr 1fr 1fr" gap="0.5rem">
                            <SkeletonDiv style={{ height: "1.5rem" }} className="standard-rounded" />
                            <SkeletonDiv style={{ height: "1.5rem" }} className="standard-rounded" />
                        </GridLayout>
                    </div>
                </div>
            ))}
        </GridLayout>
    )
}

export function SkeletonCourseTableRow() {
    return (
        <div role="skeleton-loader" className="courses-table-row">
            <div className="courses-table-information">
                <SkeletonCircle style={{"height": "2rem", "width": "2rem"}}/>
                <div>
                    <SkeletonDiv style={{"height": "1rem", "width": "100%"}} className="standard-rounded" />
                </div>
            </div>
            <div>
                <SkeletonDiv style={{"height": "1rem"}} className="standard-rounded" />
            </div>
            <div>
                <SkeletonDiv style={{"height": "1rem", "width": "2rem"}} className="standard-rounded" />
            </div>
            <div>
                <SkeletonDiv style={{"height": "1rem"}} className="standard-rounded" />
            </div>
            <div>
                
            </div>
        </div>
    )
}

export function SkeletonCardModules({ show = 4 }) {
  return (
    <GridLayout
      className="skeleton-card-grid"
      columnsTemplate="1fr 1fr 1fr 1fr"
      gap="1rem"
      style={{ margin: "1rem" }}
    >
      {[...Array(show)].map((_, i) => (
        <div
          key={i}
          className="standard-rounded standard-border skeleton-module-card"
          style={{ padding: "1rem", display: "flex", flexDirection: "column", gap: "0.5rem", height: "9.375rem", justifyContent: "center" }}>
          <SkeletonDiv style={{ height: "1.25rem", width: "80%", marginBottom: "1rem" }} className="standard-rounded" />
          <SkeletonDiv style={{ height: "2rem", width: "40%", marginBottom: "1rem"  }} className="standard-rounded" />
          <SkeletonDiv style={{ height: "1rem", width: "60%" }} className="standard-rounded" />
        </div>
      ))}
    </GridLayout>
  );
}


export function SkeletonBarChart({ height = "300px" }) {
    const bars = Array.from({ length: 12 });
    return (
      <div data-testid="skeleton-bar-chart" role="skeleton-loader" className="skeleton-bar-container" style={{ height }}>
      {bars.map((_, index) => {
        const randomHeight = Math.floor(Math.random() * 60) + 20;
        return (
          <div
            key={index}
            className="skeleton-bar"
            style={{ height: `${randomHeight}%` }}
          />
        );
      })}
    </div>
    );
}

export const SkeletonLineChart = ({ height = "300px" }) => (
  <div className="skeleton-chart" style={{ height }}>
    <div className="skeleton-bar skeleton-line" />
  </div>
);

export const SkeletonDoughnutChart = ({ size = "300px" }) => (
  <div className="skeleton-doughnut-wrapper" style={{ width: size, height: size }}>
    <div className="skeleton-doughnut" />
  </div>
);